import { ComplianceCaseStatus } from "../../graphql/supergraphEnums";
import { LandingUIState, UserAccessibleComplianceCase } from "../types";
import { InvestmentDetail } from "./types";

export const findRemediationLoadingState = (
  isTransitioning: boolean,
  complianceCase?: UserAccessibleComplianceCase | null,
): LandingUIState => {
  if (!complianceCase) {
    return LandingUIState.CaseNotFound;
  }
  if (complianceCase?.status === ComplianceCaseStatus.NotReady) {
    if (!complianceCase?.subStatus) {
      return LandingUIState.Confirmation;
    }
    if (!isTransitioning) {
      return LandingUIState.Compliance;
    }
  }
  return LandingUIState.Completion;
};

export const createInvestmentDetails = (
  investmentPosition?: UserAccessibleComplianceCase["position"] | null,
): InvestmentDetail[] => {
  if (!investmentPosition) {
    return [];
  }

  return [investmentPosition].map((position) => ({
    position: position.account?.name,
    entity: position.investmentEntity?.name,
    manager: position.arena?.name,
  }));
};
